import { Component, ViewEncapsulation } from '@angular/core';
import { ModalCommon } from '../../offers/offer-card-data.model';

@Component({
  selector: 'common-modal-content',
  template: `
    <div *ngFor="let row of data.props.content.components" class="-eva-3-pb-lg -eva-3-pl-lg -eva-3-pr-lg">
      <ng-container [ngSwitch]="row.component">
        <div *ngSwitchCase="'eva-heading'" class="modal-heading {{row.props.classes ? row.props.classes : ''}}">
            <span *ngIf="row.props.driver" class="eva-3-driver -{{row.props.driver.driver_style}}">
              <span class="driver-text ">{{row.props.driver.text}}</span>
            </span>
            <span class="eva-3-{{row.props.variant}}" [innerHTML]="row.props.text"></span>
        </div>

        <div *ngSwitchCase="'information-list'">
          <ul class="modal-list {{row.props.classes ? row.props.classes : ''}}">
            <li *ngFor="let item of row.props.items" class="modal-list-item -eva-3-mb-sm">
              <i class="-eva-3-icon-xsm eva-3-icon-{{item.icon}} -eva-3-mr-md"></i>
              <span>{{item.text}}</span>
            </li>
          </ul>
        </div>

        <div *ngSwitchCase="'separator'" class="eva-3-separator modal-separator"></div>
      </ng-container>
    </div>
  `,
  styleUrls: ['./common-modal-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CommonModalContentComponent {
  data: ModalCommon;
}
